import React from 'react';
import { useSearchParams } from 'react-router-dom';
import VideoEditor from '../VideoEditor/VideoEditor';
import CreateContent from '../CreateContentLandingPage/CreateContent';

const SmartCreateContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Check URL parameters to determine which component to show
  const hasAudioUrl = searchParams.get('audio-url');
  const hasProjectId = searchParams.get('project-id');
  
  // If audio-url is present (media creation workflow), use VideoEditor
  if (hasAudioUrl || hasProjectId) {
    return <VideoEditor />;
  }
  
  // Default to CreateContent landing page
  return <CreateContent />;
};

export default SmartCreateContent;
